/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import moment from "moment";
const AbonoAhorroHistorial = ({historial, onChange}) => {
    return (
        <>
            <div className="form-row">
                <table className="table table-borderless">
                    <thead className="thead-light">
                    <tr>                   
                        <th style={{width: '25%'}}>FECHA</th>
                        <th style={{width: '25%'}}>ABONO</th>
                        <th style={{width: '35%'}}>USUARIO ABONO</th>         
                        <th style={{width: '35%'}}>COMENTARIOS</th>        
                    </tr>
                    </thead>
                    <tbody>
                    { historial?.map((item, index) => {
                        return (
                            <tr key={index}>                                                            
                                <td>{moment(item.fecha).format('DD/MM/YYYY hh:mm a')}</td>                          
                                <td>{item.abono}</td> 
                                <td>{item.usuario}</td> 
                                <td>{item.comentarios}</td> 
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        </>
    )
};


export default AbonoAhorroHistorial;
